<p-dropdown #datesDropdown [options]="datesList" [dropdownIcon]="'pi pi-calendar'" [(ngModel)]="selectedDate"
    (ngModelChange)="onDateChange()" optionLabel="name" optionValue="value" placeholder="Select Date"
    (click)="setDropdownStyle()">
    <ng-template pTemplate="selectedItem" let-selectedItem>
        <div class="xpress-calendar-item common-color">{{ selectedItem.name }}</div>
    </ng-template>
    <ng-template pTemplate="item" let-item>
        <div class="xpress-calendar-item" *ngIf="item.value && item.value !== 'Custom'">{{ item.name }}</div>
        <div class="xpress-calendar-item" *ngIf="item.value === 'Custom'" (click)="showCustom($event)">{{ item.name }}
        </div>
        <div *ngIf="!item.value" [ngClass]="{'hidden': !showCalendars}" (click)="$event.stopPropagation()">
            <div class="flex" (click)="$event.stopPropagation()">
                <p-calendar [maxDate]="maxDate" [(ngModel)]="filterObj.startDate" [dateFormat]="'yy-mm-dd'"
                    placeholder="" id="customStartDate" class="w-full" [inline]="true"
                    (onSelect)="onStartDateSelected($event)" (click)="$event.stopPropagation()"></p-calendar>
                <div class="verticalLine" (click)="$event.stopPropagation()"></div>
                <p-calendar [minDate]="minDate" [(ngModel)]="filterObj.endDate" [dateFormat]="'yy-mm-dd'" placeholder=""
                    id="customEndDate" class="w-full" [inline]="true" (onSelect)="onEndDateSelected($event)"
                    (click)="$event.stopPropagation()"></p-calendar>
            </div>
            <hr (click)="$event.stopPropagation()">
            <div class="flex justify-content-end">
                <div class="btn btn-white btn-xpress-calendar mr-3" (click)="clear()">Clear</div>
                <div class="btn btn-default btn-xpress-calendar" (click)="refresh()">Generate</div>
            </div>
        </div>
    </ng-template>
</p-dropdown>